<div class="private-policy">
    <div class="contacts">

        <h2>
            Условия возврата
        </h2>
        <div class="info" [innerHTML]="booksReturn"></div>
    </div>
</div>